module.exports = __webpack_public_path__ + "img/sp_renew_mb.fe16c13b.png";